/* eslint-disable no-unused-vars */
import { TablePagination } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import * as React from "react";
import swal from "sweetalert";
import {
  CreateFunctionManagement,
  GetAllFunctionManagement,
  UpdateFunctionManagement,
  UpdateStatusFunctionManagement,
} from "../../../axios";
import {
  AddIcon,
  AlertMessage,
  BreadCrumbs,
  FormTextInput,
  Modal,
  NodataFound,
  SearchTable,
} from "../../../components";
import LoaderComponent from "../../../components/common/Loader";
import { FunctionForm } from "../../../forms";
import "../../../styles/tablepagination.css";
import { default as Strings, default as strings } from "../../../translations";
import { isAuthorizedFunc } from "../../../utils";
import {
  CHANGE_STATUS_FUNCTIONALITY,
  CREATE_FUNCTIONALITY,
  UPDATE_FUNCTIONALITY,
} from "../../../utils/constants";
import {
  FirstPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
} from "@mui/icons-material";

export default function SearchFunctionPage() {
  const searchFunctionTitle = Strings["FunctionManagement.searchFunctionTitle"],
    // addButton = Strings["FunctionManagement.seacrhFunctionAddButton"],
    alertMessage = Strings["FunctionManagement.AlertMessage"],
    alertTitle = Strings["FunctionManagement.AlertTitle"],
    functionName = Strings["FunctionManagement.TableHead.functionName"],
    functionDescription =
      Strings["FunctionManagement.TableHead.functionDescription"],
    activeStatus = Strings["FunctionManagement.TableHead.activeStatus"],
    action = Strings["FunctionManagement.TableHead.action"];

  const [isOpen, setIsOpen] = React.useState(false);
  const [clickedBtn, setClickedBtn] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [currentType, setCurrentType] = React.useState({});
  const [alertBox, setAlertBox] = React.useState(false);
  const [statusChangeId, setStatusChangeId] = React.useState(null);
  const [isLoader, setisLoader] = React.useState(false);
  const [errorMessage, setMessage] = React.useState(null);
  const [statusCode, setStatusCode] = React.useState();

  const [isAdd, setAdd] = React.useState(true);
  const [isUpdate, setIsUpdate] = React.useState(true);
  const [isStatus, setIsStatus] = React.useState(true);
  const [totalData, setTotalData] = React.useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [searchValue, setSearchValue] = React.useState({
    value: "",
    error: false,
    success: false,
  });
  React.useEffect(() => {
    if (isAuthorizedFunc(CREATE_FUNCTIONALITY)) {
      setAdd(true);
    } else {
      setAdd(false);
    }
  }, []);

  React.useEffect(() => {
    if (isAuthorizedFunc(UPDATE_FUNCTIONALITY)) {
      setIsUpdate(true);
    } else {
      setIsUpdate(false);
    }
  }, []);

  React.useEffect(() => {
    if (isAuthorizedFunc(CHANGE_STATUS_FUNCTIONALITY)) {
      setIsStatus(true);
    } else {
      setIsStatus(false);
    }
  }, []);
  const paths = [
    {
      name: strings["MasterConfigurationText"],
      path: "master-configuration",
    },
    {
      name: Strings["Functions"],
      path: "master-configuration/searchfunction",
    },
  ];

  const user = JSON.parse(localStorage.getItem("user"));

  const mapableData = [
    {
      dataKey: "name",
      title: functionName,
    },
    {
      dataKey: "description",
      title: functionDescription,
    },
    {
      dataKey: "is_active",
      title: activeStatus,
      isStatus: true,
    },
    {
      dataKey: "id",
      title: action,
      isAction: true,
    },
  ];
  //  modal works
  const openAddModal = () => {
    setIsOpen(true);
  };
  const handleModalClose = () => {
    setMessage(null);
    setIsOpen(false);
  };

  const handleSelectBtn = (btn) => {
    setClickedBtn(btn);
  };
  const getAllFunction = () => {
    setisLoader(true);
    GetAllFunctionManagement(rowsPerPage, page, searchValue.value)
      .then((res) => {
        setisLoader(false);
        setRows(res.data.data);
        setTotalData(res.data.total);
      })
      .catch((e) => {
        setisLoader(false);
        setMessage(e.response);
      });
  };
  React.useEffect(() => {
    getAllFunction();
  }, [rowsPerPage, page]);
  const createFunction = (formData) => {
    setisLoader(true);
    CreateFunctionManagement(formData)
      .then((res) => {
        setisLoader(false);
        swal({
          title: "Success!",
          text: "Created Sucessfully",
          icon: "success",
        });
        setRows([res.data.data, ...rows]);
        handleModalClose();
      })
      .catch((e) => {
        setisLoader(false);
        setMessage(e.response.data.message);
      });
  };

  const updateFunction = (formData) => {
    setisLoader(true);
    const id = currentType.id;
    UpdateFunctionManagement(id, formData)
      .then((res) => {
        if (res.status === 200) {
          setisLoader(false);
          // const result = rows.map((ele) => {
          //   if (ele.id === res.data.data.id) {
          //     return {
          //       ...ele,
          //       module_id: ele.module_id,
          //       name: res.data.data.name,
          //       code: res.data.data.code,
          //       description: res.data.data.description,
          //       ui_code: res.data.data.ui_function_code,
          //     };
          //   } else {
          //     return ele;
          //   }
          // });
          swal({
            title: "Success!",
            text: "Updated Sucessfully",
            icon: "success",
          });
          // setRows(result);
          handleModalClose();
        }
      })
      .catch((e) => {
        setisLoader(false);
        setMessage(e.response.data.message);
      });
  };
  const handleChangeActiveStatus = (id, status) => {
    setStatusChangeId(id);
    setStatusCode(status);
    setAlertBox(true);
  };

  const selectModal = () => {
    return (
      <FunctionForm
        setMessage={setMessage}
        errorMessage={errorMessage}
        handleChangeData={
          clickedBtn === "add" ? createFunction : updateFunction
        }
        actionType={clickedBtn}
        initialValue={clickedBtn !== "add" ? currentType : {}}
        handleModalClose={handleModalClose}
      />
    );
  };
  const handleChangeCancel = () => {
    setAlertBox(false);
  };
  const handleChangeSuccess = () => {
    setisLoader(true);
    const statuss = { status: 1 - statusCode };
    UpdateStatusFunctionManagement(statusChangeId, statuss)
      .then((res) => {
        const result = rows.map((elem) => {
          if (elem.id === res.data.data.id) {
            return { ...elem, is_active: res.data.data.is_active };
          } else {
            return elem;
          }
        });
        setRows(result);
        setisLoader(false);
        setAlertBox(false);
      })
      .catch((e) => {
        setisLoader(false);
      });
  };

  const handleChangeEdit = (id) => {
    openAddModal();
    const result = rows.find((row) => {
      return row.id === id;
    });
    setCurrentType(result);
    handleSelectBtn("edit");
  };
  const [open, setOpen] = React.useState(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  const handleSearch = (searchData) => {
    const data = searchData.value;
    setSearchValue(searchData);
    if (searchData.value === "") {
      setisLoader(true);
      GetAllFunctionManagement(rowsPerPage, page, searchData.value)
        .then((res) => {
          setisLoader(false);
          setRows(res.data.data);
          setTotalData(res.data.total);
        })
        .catch((e) => {
          setisLoader(false);
          setMessage(e.response);
        });
    }
    // // const filterData = tempData.filter((d) => {
    //     return d[searchProp].toLowerCase().includes(data);
    // // })
    // if (data === "") {
    //   setAllData(tempData);
    // } else {
    //   setAllData(filterBuilderData(allData, query));
    // }
  };
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    getAllFunction();
  };

  function CustomTablePaginationActions(props) {
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div style={{ flexShrink: 0, marginLeft: "1rem" }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          <FirstPage />
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          <LastPage />
        </IconButton>
      </div>
    );
  }

  return (
    <>
      <div className="container">
        {isLoader ? <LoaderComponent /> : null}
        <Modal onHandleClose={handleModalClose} isOpen={isOpen}>
          {selectModal()}
        </Modal>
        <div className="row mt-4">
          <div className="col">
            <h3> {searchFunctionTitle} </h3>
            <BreadCrumbs pathList={paths} />
          </div>
          {isAdd && (
            <div className="col-auto">
              <span className="addButton">
                <IconButton
                  onClick={() => {
                    openAddModal();
                    handleSelectBtn("add");
                  }}
                >
                  <AddIcon />
                </IconButton>
              </span>
            </div>
          )}
          <div className="row">
            {alertBox && (
              <AlertMessage
                title={alertTitle}
                message={alertMessage}
                onChangeCancel={handleChangeCancel}
                onChangeSucess={handleChangeSuccess}
              />
            )}
            <div className="UserbudgetTable">
              <div className="col-12">
                <form onSubmit={handleSearchSubmit}>
                  <FormTextInput
                    type="text"
                    className="searchBarUser mb-3"
                    placeholder={`Search `}
                    Value={searchValue.value}
                    onChangeText={handleSearch}
                    inputStyle={{ border: "none" }} 
                    editable
                  />
                </form>
                {rows?.length > 0 ? (
                  <>
                    <SearchTable
                      isUpdate={isUpdate}
                      isStatus={isStatus}
                      // placeholder="function name"
                      data={rows}
                      mapableData={mapableData}
                      searchProp={["name"]}
                      handleChangeActiveStatus={handleChangeActiveStatus}
                      handleChangeEdit={handleChangeEdit}
                    />
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 15]}
                      component="div"
                      count={totalData}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={CustomTablePaginationActions}
                    />
                  </>
                ) : (
                  <>
                    {isLoader ? (
                      <LoaderComponent />
                    ) : (
                      <NodataFound
                        onClick={() => {
                          openAddModal();
                          handleSelectBtn("add");
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          {/* <Footer /> */}
        </div>
      </div>
    </>
  );
}
